import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

import ErrorBoundary from '@/components/ErrorBoundary';
import LoginPage from '@/pages/LoginPage';
import IndexRedirect from '@/pages/IndexRedirect';
import AppLayout from '@/components/layout/AppLayout';
import CommandesPage from '@/pages/CommandesPage';
import DashboardPage from '@/pages/DashboardPage';
import ProduitsPage from '@/pages/ProduitsPage';
import ProduitDetailPage from '@/pages/ProduitDetailPage';
import CallCentersPage from '@/pages/CallCentersPage';
import UsersPage from '@/pages/UsersPage';
import ParametresPage from '@/pages/ParametresPage';
import MessageriePage from '@/pages/MessageriePage';

// Nivo CRM — routing (Phase 2) + global Toaster + ErrorBoundary (Phase 9).
// Toaster defaults:
//   - Global position: top-right (success/erreur standard).
//   - Per-toast overrides live in `lib/toast.js` (e.g. status-change → bottom-right, 2 s).
// ErrorBoundary catches uncaught React render errors and shows a French
// fallback page with a reload button (never a raw white screen).
function App() {
    return (
        <ErrorBoundary>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/" element={<IndexRedirect />} />
                        <Route element={<AppLayout />}>
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/commandes" element={<CommandesPage />} />
                            <Route path="/messagerie" element={<MessageriePage />} />
                            <Route path="/produits" element={<ProduitsPage />} />
                            <Route path="/produits/:id" element={<ProduitDetailPage />} />
                            <Route path="/call-centers" element={<CallCentersPage />} />
                            <Route path="/utilisateurs" element={<UsersPage />} />
                            <Route path="/parametres" element={<ParametresPage />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    position="top-right"
                    richColors={false}
                    closeButton={false}
                    duration={3000}
                    data-testid="app-toaster"
                />
            </div>
        </ErrorBoundary>
    );
}

export default App;
